import { render, staticRenderFns } from "./PopupV2.vue?vue&type=template&id=64d833ee&scoped=true&"
import script from "./PopupV2.vue?vue&type=script&lang=js&"
export * from "./PopupV2.vue?vue&type=script&lang=js&"
import style0 from "./PopupV2.vue?vue&type=style&index=0&id=64d833ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d833ee",
  null
  
)

export default component.exports